module.exports = __webpack_public_path__ + "img/54.969f2e58.svg";